import React from "react";
import { Box } from "@mui/material";
import CardDecesso from "./CardDecesso";
import CardGaranziaOpzionale from "./CardGaranziaOpzionale";
import PremioTotaleCard from "./PremioTotaleCard";

const StepPersonalizza = ({
  vitaGaranzie,
  onGaranziaToggle,
  onSliderChange,
  premioTotale,
  onBack,
  onContinua,
}) => {
  return (
    <Box sx={{ maxWidth: 900, mx: "auto" }}>
      <CardDecesso
        vitaGaranzie={vitaGaranzie}
        onSliderChange={onSliderChange}
      />

      <CardGaranziaOpzionale
        garanzia="invalidita"
        vitaGaranzie={vitaGaranzie}
        onToggle={onGaranziaToggle}
        title="Invalidità Totale Permanente"
        priceKey="invalidita"
      />

      <CardGaranziaOpzionale
        garanzia="malattiaGrave"
        vitaGaranzie={vitaGaranzie}
        onToggle={onGaranziaToggle}
        title="Malattia Grave"
        priceKey="malattiaGrave"
      />

      <CardGaranziaOpzionale
        garanzia="inabilita"
        vitaGaranzie={vitaGaranzie}
        onToggle={onGaranziaToggle}
        title="Inabilità Totale Temporanea"
        priceKey="inabilita"
      />

      <PremioTotaleCard
        premioTotale={premioTotale}
        onBack={onBack}
        onContinua={onContinua}
      />
    </Box>
  );
};

export default StepPersonalizza;
